import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface AdminLayoutProps {
  children: React.ReactNode;
}

interface NavItem {
  path: string;
  label: string;
}

interface NavGroup {
  label: string;
  items: NavItem[];
}

const ADMIN_NAV: (NavItem | NavGroup)[] = [
  { path: '/admin', label: 'Dashboard' },
  { path: '/admin/content', label: 'Content' },
  { path: '/admin/question-review', label: 'Question Review' },
  {
    label: 'Quizzes',
    items: [
      { path: '/admin/competitive', label: 'History' },
      { path: '/admin/competitive-upcoming', label: 'Upcoming' },
    ],
  },
  { path: '/admin/users', label: 'Users' },
  { path: '/admin/contact-submissions', label: 'Contact' },
  { path: '/admin/difficulty-manager', label: 'Difficulty' },
];

const isNavItem = (x: NavItem | NavGroup): x is NavItem => 'path' in x;

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const location = useLocation();
  const isDashboard = location.pathname === '/admin';

  return (
    <div className="admin-layout">
      <aside className="admin-nav">
        <nav className="admin-nav__inner" aria-label="Admin navigation">
          <Link to="/" className="admin-nav__home" aria-label="Back to site">
            ← Site
          </Link>
          <ul className="admin-nav__list">
            {ADMIN_NAV.map((item) => {
              if (isNavItem(item)) {
                return (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className={`admin-nav__link ${location.pathname === item.path ? 'admin-nav__link--active' : ''}`}
                    >
                      {item.label}
                    </Link>
                  </li>
                );
              }
              const isGroupActive = item.items.some((i) => location.pathname === i.path);
              return (
                <li key={item.label} className="admin-nav__group">
                  <span className={`admin-nav__group-label ${isGroupActive ? 'admin-nav__group-label--active' : ''}`}>
                    {item.label}
                  </span>
                  <ul className="admin-nav__sublist">
                    {item.items.map((sub) => (
                      <li key={sub.path}>
                        <Link
                          to={sub.path}
                          className={`admin-nav__link admin-nav__link--sub ${location.pathname === sub.path ? 'admin-nav__link--active' : ''}`}
                        >
                          {sub.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
              );
            })}
          </ul>
        </nav>
      </aside>
      <main className="admin-main">
        {!isDashboard && (
          <Link to="/admin" className="admin-back">
            ← Dashboard
          </Link>
        )}
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;
